<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
@import "https://at.alicdn.com/t/font_2343604_xuf36z825it.css";
body,
p,
ul,
ol,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
td,
input,
textarea,
select,
option {
  margin: 0;
  padding: 0;
}
body {
  font-family: "微软雅黑";
  background: #ffffff;
  overflow-x:hidden;
}
ul,
ol,
li {
  list-style: none;
}
a {
  text-decoration: none;
}
img {
  border: none;
}

</style>
